var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCabbage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 47,
  height: 47,
  viewBox: "0 0 47 47"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00694E",
  d: "M34.428 42.585c-10.657 6.153-24.286 2.5-30.439-8.157s-2.502-24.286 8.156-30.44c10.658-6.152 24.285-2.5 30.439 8.158 6.153 10.657 2.502 24.285-8.156 30.439"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#363735",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M34.428 42.585c-10.657 6.153-24.286 2.5-30.439-8.157s-2.502-24.286 8.156-30.44c10.658-6.152 24.285-2.5 30.439 8.158 6.153 10.657 2.502 24.285-8.156 30.439"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#363735",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M22.788 1.006s8.96 8.095-1.318 13.25c14.73 8.537 2.442 27.06-10.466 27.628"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#363735",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M27.446 29.017s6.098-3.688 7.333 2.504c1.237 6.192 6.253-13.3 10.697-6.175m-17.344-1.961s6.624-2.19 9.805 6.37M13.096 10.458s-10.03 11.13-7.2 26.765"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#363735",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m3.386 13.258 3.548 8.615 7.78-2.436M5.397 32.173l8.783-3.629m1.667 12.308s14.465 4.443 24.404-7.088"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#363735",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m27.967 37.181-2.364 4.331 2.091 3.623m5.472-9.174-.493 3.582 2.702 2.463M25.208 11.373s9.618 10.486 13.216 7.073c-1.197 5.258 1.829 7.41 1.829 7.41m-7.461-22.76S43.965 10.68 43.437 23.76m-1.04-7.611-1.298 3.649M37.587 7.622l-2.404 5.789"
}))));
export default SvgCabbage;